import { Injectable, signal } from '@angular/core';

export type LoaderMessage = 'analyzing' | 'uploading' | 'translating' | null;

@Injectable({ providedIn: 'root' })
export class LoaderMessageService {
  readonly message = signal<LoaderMessage>(null);

  set(message: LoaderMessage): void {
    this.message.set(message);
  }
}
